import {AbstractStorageModule} from "@/services/storage/AbstractStorageModule";

export class Customer extends AbstractStorageModule {
  customerId: null|number = null;
  contentLanguage: null|string = null;
  currency: null|string = null;
  microSessionCount: null|number = null;
  microSessionId: null|string = null;
  visitToken: null|string = null;
  uniqToken: null|string = null;

  resolve() {
    this.resolveCustomerId();
    this.resolveVisitor();
  }

  resolveCustomerId() {
    // @ts-ignore
    this.customerId = window?.ShopifyAnalytics?.meta?.page?.customerId ?? null;
  }

  resolveVisitor() {
    try {
      // @ts-ignore
      const trekkieDefaultAttributes: null|Record<string, any> = window?.trekkie?.trekkie?.defaultAttributes ?? null;
      if(!trekkieDefaultAttributes) return;

      this.contentLanguage = trekkieDefaultAttributes?.contentLanguage;
      this.currency = trekkieDefaultAttributes?.currency;
      this.microSessionCount = trekkieDefaultAttributes?.microSessionCount;
      this.microSessionId = trekkieDefaultAttributes?.microSessionId;
      this.visitToken = trekkieDefaultAttributes?.visitToken;
      this.uniqToken = trekkieDefaultAttributes?.uniqToken; // main customer token
    } catch (e) {}
  }

  // NOTE: "native" way for shopify to get only visitor uuid (not used as we are using more data from source object)
  resolveToken() {
    try {
      // @ts-ignore
      const shopifyAnalyticsLib = window?.ShopifyAnalytics?.lib;
      if(!shopifyAnalyticsLib) return;

      let token = shopifyAnalyticsLib.user().traits().uniqToken;
    } catch (e) {}
  }

}
